export default "__VITE_ASSET__CesUMDDy__"